import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react";
import {SparkSwiperComponent} from "../../../spark-swiper/spark-swiper.component";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {
    VideoSlidesOnboardingComponent
} from "../../../video-slides/parts/on-boarding/video-slides-onboarding.component";
import {VideoSlidesArenaSwiperBox} from "./video-slides-arena-swiper.box";
import {VIDEO_SLIDES_ARENA_SWIPER_ID} from "../video-slides-arena.consts";
import {CyClass} from "../../../../../common/cy-classes";

export const VideoSlidesArenaSwiperComponent: React.FC = observer(() => {
    const services = useServices();
    const [showOnBoarding, setShowOnBoarding] = useState(!services.videoSlides.onBoardingWasShown);

    const swiperController = services.videoSlides.swiperController;

    useEffect(() => {
        if (showOnBoarding) {
            services.analytics.sendOrbitUserFlowEvent('videoSlides', 'show', 'onBoarding');
        }

        if (swiperController.sparkSwiperSwipeAnimation.isAnimatedSwipingInProgress) {
            swiperController.sparkSwiperSwipeAnimation.stopAnimatedSwiping();
        }
    }, [showOnBoarding, services.analytics, swiperController.sparkSwiperSwipeAnimation]);

    const dismissOnBoarding = () => {
        swiperController.sparkSwiperSwipeAnimation.startAnimatedSwiping();
        setShowOnBoarding(false);
    }


    const renderOnBoarding = () => {
        if (showOnBoarding) {

            return (
                <VideoSlidesOnboardingComponent onDismiss={dismissOnBoarding} />
            )
        }
        return null;
    }

    return (
        <VideoSlidesArenaSwiperBox id={VIDEO_SLIDES_ARENA_SWIPER_ID} className={CyClass('cy-video-slides-arena-swiper')}>
            {renderOnBoarding()}
            <SparkSwiperComponent swiperController={swiperController} />
        </VideoSlidesArenaSwiperBox>

    )
});